import React from 'react'
import Select from 'react-select'
import { useThemeMode } from '../../../_metronic/partials'
import { SelectStyles } from '../../../components/Select'
import { ClientListFilterType } from '../../modules/clients/core/_rest_models'

const FastTrackFilter = ({
  onChangeSelect,
  filterData,
}: {
  onChangeSelect: (selectData: any) => void
  filterData: Partial<ClientListFilterType>
}) => {
  const { mode: theme } = useThemeMode()
  const options = [
    { label: 'Да', value: true },
    { label: 'Нет', value: false },
  ]

  const getFastTrackValue = () => {
    if (filterData.fastTrack === false) {
      return { label: 'Нет', value: false }
    }
    if (filterData.fastTrack === true) {
      return { label: 'Да', value: true }
    }
    return null
  }

  return (
    <Select
      onChange={(data) => (data ? onChangeSelect(data?.value) : onChangeSelect(null))}
      options={options}
      isClearable={true}
      placeholder={'Фаст трек'}
      value={getFastTrackValue()}
      styles={SelectStyles(theme)}
    />
  )
}

export default FastTrackFilter
